<!-- =========================================================================================
  File Name: CompanyEdit.vue
  Description: Company Edit Page
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/company/pixinvent
========================================================================================== -->

<template>
  <div id="page-role-edit">
    <vs-alert color="danger" title="Role Not Found" :active.sync="not_found">
      <span>Role record with id: {{ $route.params.id }} not found. </span>
      <span>
        <span>Check </span><router-link :to="{name:'role.list'}" class="text-inherit underline">All
        Roles</router-link>
      </span>
    </vs-alert>

    <vs-row v-if="data">
      <vs-col>
        <vs-row>
          <vs-col>
            <h1 class="mb-4">{{ data.RoleName }}</h1>
          </vs-col>
        </vs-row>
        <role-edit-details :data="data" />
      </vs-col>
    </vs-row>


  </div>
</template>

<script>

import CompanyEditGeneralDetails from "../../companies/edit/CompanyEditGeneralDetails";
import CompanyEditProfile from "@/views/pages/companies/edit/CompanyEditProfile";
import CompanyEditButtons from "@/views/pages/companies/edit/CompanyEditButtons";
import RoleEditDetails from "@/views/pages/role/edit/RoleEditDetails";

export default {
  components: {
    RoleEditDetails,
    CompanyEditGeneralDetails,
    CompanyEditProfile,
    CompanyEditButtons,
  },
  data () {
    return {
      data: null,
      not_found: false,

    }
  },
  methods: {
    async fetch(roleId) {
      try {
        const { data } = await this.$api.roles.get(roleId, { params: {'include' : 'applications'} });
        this.data = data.data;
        if (this.data.IsDeleted) {
          this.data = null;
        }
      } catch (e) {
        console.error(err)
      } finally {
        if (!this.data) {
          this.not_found = true
        }
      }
    }
  },
  created () {
    this.fetch(this.$route.params.id)
  }
}

</script>
